import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=708dc46c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=708dc46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708dc46c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708dc46c')) {
      api.createRecord('708dc46c', component.options)
    } else {
      api.reload('708dc46c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=708dc46c&scoped=true&", function () {
      api.rerender('708dc46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2faaTuQKO2l2D/JS/comp/GuestBox.vue"
export default component.exports